import React from 'react'
import './Projects.css';
// import Cipher from './programs/Cipher.js';

function projects() {
  return (
    <div>
      <div className="pro_container" id='program'>
        <div className='spacer pro_bg_layer'></div>
        <div className="projects_container">
          <p className='coming'>COMING SOON</p>
          {/* <Cipher /> */}
        </div>
      </div>
    </div>
  )
}

export default projects
